import React, { useRef, useEffect, useState } from 'react'
import { toaster, UploadIcon, Text, Pane } from 'evergreen-ui'
import ProgressBar from "./ProgressBar"
import { createBrowserHistory } from '@remix-run/router';
// drag drop file component

export function DropZone(props) {

  const allowedExtensions = ["dxf"];
  // drag state
  const [dragActive, setDragActive] = useState(false);
  const [progress, setProgress] = useState(0);
  // ref
  const inputRef = useRef(null);
  const btnRef = useRef(null);
  const formRef = useRef(null);




  // handle drag events
  const handleDrag = function (e) {
    if (e.dataTransfer.types.indexOf('book') >= 0 || e.dataTransfer.types.indexOf('folder') >= 0 ) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      formRef.current.classList.add('drop-zone');
      setDragActive(true);
    } else if (e.type === "dragleave") {
      formRef.current.classList.remove("drop-zone");
      setDragActive(false);
    }
  };


  //Validate File
  function fileCheck(file) {
    return new Promise((res, rej) => {
      let ext = file.name? file.name.split('.').pop():'';
      if (allowedExtensions.indexOf((ext ?? '').toLowerCase()) >= 0 == false) {
        toaster.danger('Please reselect a file', {
          description: <><Text>{"File must be of the following types: " + allowedExtensions.join(', ')}</Text><br /><Text>{"Uploaded filename: " + file.name}</Text></>
        });
        btnRef.current.innerHTML = 'Upload a file';
        props.onChange(null)
        return rej("Invalid Type")
      }
      // btnRef.current.innerHTML = file.name;
      return res(file)


    })
  };

  const doUploads = function (files) {
    if (files) {
      let p = [];
      for (let i = 0; i < files.length; i++) {
        let file = files.item(i);
        p.push(fileCheck(file))
      }

      Promise.all(p).then((r) => {
        toaster.notify('Uploaded ' + p.length);
        props.onChange(r)
      })
    }
  }

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files.length > 0) {
      doUploads(e.dataTransfer.files);
    }

  };

  // triggers when file is selected with click
  const handleChange = function (e) {
    e.preventDefault();
    doUploads(e.target.files);
  };

 

  return (
    <form className="form-file-upload" ref={formRef} onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()} style={{ display: "flex", flexDirection: "column-reverse" }}>
      {progress > 0 && <ProgressBar completed={progress} />}
      {props.children}

      <input ref={inputRef} multiple="multiple" type="file" accept={allowedExtensions.map(v => '.' + v).join(', ')} id="input-file-upload" className="input-file-upload" onChange={handleChange} />

      <label className={`${dragActive ? "drag-active" : ""} label-file-upload`} htmlFor="input-file-upload" >
        <div>
          <p><UploadIcon color={"#206BE1"} size={40} /></p>
          <Text>Drag and drop your file here or </Text>
          <Text>click here to <button className="upload-button" ref={btnRef} onClick={() => { inputRef.current.click(); }}>Upload a file </button></Text>
        </div>
      </label>
      {dragActive && <div className="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
    </form>
  );
};
